import { MenuSub } from '@/components/menu';
import { MegaMenuSubDropdown } from './components';
const MegaMenuSubDocuments = items => {
  const documentsItem = items.find(
    item => item.title === 'Documents ' || item.title === 'Documents'
  );
  return <MenuSub className="menu-default py-2.5 lg:w-[225px]">
    {documentsItem.children && MegaMenuSubDropdown(documentsItem.children)}
  </MenuSub>;
};
export { MegaMenuSubDocuments };